import React from "react";
import "../styles/skeleton.css";

const Skl: React.FC<{ className?: string; style?: React.CSSProperties }> = ({
  className = "",
  style,
}) => <div className={`skeleton ${className}`} style={style} />;

const HeroSkeleton: React.FC = () => (
  <header
    className="position-relative text-white"
    style={{ padding: "120px 0 160px 0" }}
  >
    <div className="container">
      <div className="row">
        <div className="col-lg-7">
          <Skl
            style={{ width: "180px", height: "28px", marginBottom: "16px" }}
          />

          <Skl
            style={{ width: "70%", height: "48px", marginBottom: "16px" }}
          />

          <div style={{ marginBottom: "24px" }}>
            <Skl style={{ width: "100%", height: "16px", marginBottom: "8px" }} />
            <Skl style={{ width: "65%", height: "16px" }} />
          </div>

          <div className="d-flex gap-3">
            <Skl style={{ width: "160px", height: "48px", borderRadius: "8px" }} />
            <Skl style={{ width: "180px", height: "48px", borderRadius: "8px" }} />
          </div>
        </div>
      </div>
    </div>
  </header>
);

export default HeroSkeleton;
